var React = require('react');

function ButtonArrow (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M13 2.5H1V0.5H15V14.5H13V2.5Z","fill":"currentColor","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M14.7072 2.20718L1.70718 15.2072L0.292969 13.793L13.293 0.792969L14.7072 2.20718Z","fill":"currentColor","key":1})]);
}

ButtonArrow.defaultProps = {"width":"15","height":"16","viewBox":"0 0 15 16","fill":"none"};

module.exports = ButtonArrow;

ButtonArrow.default = ButtonArrow;
